import { isNil } from "ramda";
import React from "react";
import { useTranslation } from "react-i18next";
import { Table } from "reactstrap";
import roundTo from "round-to";
import "./PriceReport.scss";

/**
 * interface Product {
 *   id: number
 *   name: string
 *   productData?: {
 *     price: string
 *     priceChange: string
 *     priceChangeType: 'none' | 'rise' | 'decline'
 *   }
 * }
 */
const TableComponent = ({ productList, header }) => {
  const { t } = useTranslation(["averagePrices"]);

  return (
    <Table className="prices-table">
      <thead>
      {header}
      </thead>
      <colgroup>
        <col width="33.3%" />
        <col width="33.3%" />
        <col width="33.3%" />
      </colgroup>
      {productList.length > 0 ? (
        <tbody>
          {productList.map(({ id, name, productData }) => {
            const { price, priceChange, priceChangeType } = productData;

            if (!price && !priceChange) {
              return (
                <tr key={`${id}${name}`}>
                  <td className="prices-table__type">{name}</td>
                  <td colSpan="2" style={{ textAlign: "right" }}>
                    {t("averagePrices:noData")}
                  </td>
                </tr>
              );
            }

            return (
              <tr key={`${id}${name}`}>
                <td className="prices-table__type">{name}</td>
                <td className="prices-table__price">{price || "-"}</td>
                <td
                  className={`prices-table__change prices-table__change_${priceChangeType}`}
                >
                  {priceChange || "-"}
                </td>
              </tr>
            );
          })}
        </tbody>
      ) : (
        <tbody>
          <tr>
            <td style={{ textAlign: "center" }}>{t("averagePrices:noData")}</td>
          </tr>
        </tbody>
      )}
    </Table>
  );
};

export const createTableRow = (
  { id, name, currentPrice, percentagePriceChange },
  weightMeasure = "tons"
) => {
  let priceChangeType = "none";
  if (percentagePriceChange > 0) {
    priceChangeType = "rise";
  }
  if (percentagePriceChange < 0) {
    priceChangeType = "decline";
  }

  const priceMeasure = (() => {
    switch (weightMeasure) {
      case "kg":
        return "zł/kg";
      case "100kg":
        return "zł/100kg";
      default:
        return "zł/t";
    }
  })();

  return {
    id,
    name,
    productData: {
      price: !isNil(currentPrice)
        ? `${roundTo(currentPrice, 2)} ${priceMeasure}`
        : "",
      priceChange: !isNil(percentagePriceChange)
        ? `${percentagePriceChange.toFixed(2)}%`
        : "",
      priceChangeType,
    },
  };
};

export default TableComponent;
